import React from 'react';
import cls from './WeeksModeCharter.module.css';
import classNames from 'classnames';
import moment from 'moment/moment';
import { CharterItem } from '../../../../../../UI/CharterItem/CharterItem';

export const WeekItemCharter = ({ charter, week }) => {
    const charterDate = moment(charter.planned.start_date).format('DD.MM.YYYY');
    const nowDate = moment().format('DD.MM.YYYY');

    const isRenderDays = week.days.includes(charterDate) || week.days.includes(nowDate);

    return (
        <div className={classNames(cls.week, { [cls.factWrapper]: isPlanFact })}>
            {isRenderDays &&
                week.days.map((day) => (
                    <div
                        key={day + Math.random().toString(36)}
                        data-id={day}
                        className={classNames(cls.day, {
                            [cls.factWrapper]: isPlanFact,
                            [cls.nowDate]: day === nowDate,
                        })}
                    >
                        {charterDate === day && (
                            <CharterItem isPlanFact={isPlanFact} charter={charter} />
                        )}
                    </div>
                ))}
        </div>
    );
};
